var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "ds-control dsf-fast-form-layout pc",
      class: _vm.getCss,
      style: { "background-color": _vm.backgroundColor },
    },
    [
      _c(
        "div",
        {
          staticClass: "dsf-fast-form-layout_content",
          attrs: { columns: _vm.columns, "slot-name": "default" },
        },
        [_vm._t("default")],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }